import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-textbox-answer',
  templateUrl: './textbox-answer.component.pug',
  styleUrls: ['./textbox-answer.component.scss'],
  standalone: false
})
export class TextboxAnswerComponent implements OnInit {
  @Input() options: any;
  @Output() optionsChange: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  selectmultiple(){
    this.options.multiple_line = true;
    this.options.single_line = false;
    this.optionsChange.emit(this.options);
  }
  selectSingle(){
    this.options.multiple_line = false;
    this.options.single_line = true;
    this.optionsChange.emit(this.options);
  }

}
